import { Attributes, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class AssetType extends ModelBase {
    static typeName = "AssetType";

    public assetTypeId: number = 0;

    @Rules.StringLength(10)
    @Rules.Required()
    public assetTypeCode: string = "";

    @Rules.StringLength(50)
    @Rules.Required()
    @Attributes.Display("Asset Type")
    @Attributes.DisplayMember()
    public assetTypeName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.assetTypeCode) {
            return "New asset type";
        } else {
            return this.assetTypeCode;
        }
    }
}